import { authorizedPATCH } from 'helpers/requester_next/requester';
import endpoints from 'constants/endpoints';

export const updateBand = async updateParams => authorizedPATCH(endpoints.updateBandInfo, updateParams);

export default {};
